module.exports = __webpack_public_path__ + "assets/img/terms.2801239d.svg";